import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';


import {LoginHelper} from '../../helpers';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService,} from '../../_services/index';
import {ClientITProfile} from "../../_models";
import {saveAs as importedSaveAs} from "file-saver";

@Component({
    standalone: false,
  selector: 'generate-crm-component',
  templateUrl: 'generateCrm.component.html'
})

export class GenerateCrmComponent implements OnInit {

  itProfiles: ClientITProfile[];
  itProfile: ClientITProfile;

  constructor(
    public dialogRef: MatDialogRef<GenerateCrmComponent>,
    public projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public clientProfileService: ClientProfileService,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.clientProfileService.getClientProfiles(LoginHelper.getTenantName())
      .subscribe((clientITProfiles: ClientITProfile[]) => {

        if (clientITProfiles == null) {
          return;
        }

        this.itProfiles = this.data.project.clientITProfileIds.split(';').map(i => clientITProfiles.find(p => p.clientITProfileId == i)).filter(p => p);

        if (this.itProfiles.length > 0) {
          this.itProfile = this.itProfiles[0];
        }
      });

  }

  generate(): void {
    this.dialogRef.close();

    this.projectService.downloadCRM(this.data.project.projectId, this.itProfile.clientITProfileId).subscribe(blob => {
        importedSaveAs(new Blob([blob]), 'CRM.xlsx');
      },
      error => {
        const errorMessage = 'Error during generation CRM';
        this.alertService.error(errorMessage);
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
